import { render, staticRenderFns } from "./form-general.vue?vue&type=template&id=ed6489a2&scoped=true"
import script from "./form-general.vue?vue&type=script&lang=js"
export * from "./form-general.vue?vue&type=script&lang=js"
import style0 from "./form-general.vue?vue&type=style&index=0&id=ed6489a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6489a2",
  null
  
)

export default component.exports